import { gql } from "@apollo/client";
import { ApolloQueryResult } from "@apollo/client/core/types";
import { useApolloClient, useMutation } from "@apollo/client/react";
import { signOut } from "aws-amplify/auth";
import { useAuth } from "common/auth/Auth";
import React, { cloneElement, ComponentProps, ReactElement } from "react";

const SIGN_OUT = gql`
  mutation BackendSignOut {
    backendSignOut {
      success
    }
  }
`;

export const LogoutButton: React.FC<{
  children: ReactElement<ComponentProps<"button">>;
}> = ({ children }) => {
  const { setSignoutInProgress } = useAuth();
  const [backendSignOut] = useMutation(SIGN_OUT);
  const client = useApolloClient();

  async function logout(
    resetStore: () => Promise<ApolloQueryResult<unknown>[] | null>,
  ) {
    try {
      await signOut();
      await backendSignOut();
      await resetStore();
      setSignoutInProgress();
    } catch (error) {
      console.error("Logout failed", error);
    }
  }

  return (
    <>
      {cloneElement(children, {
        ...children.props,
        onClick: () => {
          void logout();
        },
      })}
    </>
  );
};
